export default __webpack_public_path__ + "static/media/right-boot-print.86470fa9.png";